import { render, staticRenderFns } from "./SocietyDashMatchContainer.vue?vue&type=template&id=56dcf28c&scoped=true"
import script from "./SocietyDashMatchContainer.vue?vue&type=script&lang=js"
export * from "./SocietyDashMatchContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56dcf28c",
  null
  
)

export default component.exports